import { ShoppingCart } from '@pixum/web-header';

type ShoppingCartStreamingSkeletonProps = {
  desktopVariant?: boolean;
};

/**
 * Skeleton fallback for ShoppingCartStreaming Suspense boundary.
 *
 * Renders ShoppingCart without an order count — visually shows the cart icon
 * without a badge while the streaming fetch is in flight.
 */
export function ShoppingCartStreamingSkeleton({ desktopVariant }: ShoppingCartStreamingSkeletonProps) {
  return <ShoppingCart orders={undefined} desktopVariant={desktopVariant} />;
}
